module.exports = __webpack_public_path__ + "img/44.c82511c3.gif";